import { render, staticRenderFns } from "./ClientNotes.vue?vue&type=template&id=acef9fec&scoped=true"
import script from "./ClientNotes.vue?vue&type=script&lang=js"
export * from "./ClientNotes.vue?vue&type=script&lang=js"
import style0 from "./ClientNotes.vue?vue&type=style&index=0&id=acef9fec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acef9fec",
  null
  
)

export default component.exports